// extracted by mini-css-extract-plugin
export default {"container":"mKs5k4w8w0dnx9eg7RFBBg==","image":"wUOLlM+TJsndfS1Kl-DaGg==","textContainer":"qQUL-4pUCvrHsDUVKGokQQ==","qontoHeader":"JnWiQjPbWSliTZY9DuvjBQ=="};